export default "__VITE_ASSET__6b03de81__"